import { loadPlaybooks } from '../common/api';

const playbooks = {
    name: 'playbooks',
    state: {
        loaded: false, 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.pid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.pid]: {
                        ...state.byId[payload.pid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.oid]: {
                        ...state.byId[payload.oid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.pid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedPlaybooks: ( state, payload ) => {
            return {
                ...state,
                loaded: true,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadPlaybooks( { aid, uid } ) {
            const list = await loadPlaybooks( aid, uid );
            let byId = {};
            list.forEach( c => byId[c.pid] = c );
            dispatch.playbooks.loadedPlaybooks( byId );
        },
        insert( { pid, cdc } ) {
            dispatch.playbooks.cdcInsert( { pid, cdc } );
        },
        modify( { oid, cdc } ) {
            dispatch.playbooks.cdcModify( { oid, cdc } );
        },
        remove( { pid } ) {
            dispatch.playbooks.cdcRemove( { pid } );
        },
        setCurrent( { pid } ) {
            dispatch.playbooks.setCurrentId( { pid } );
        }
    } )
}

export default playbooks;